























































import {Component, Mixins, Prop} from 'vue-property-decorator';
import {TranslateResult} from 'vue-i18n';
import TranslatedRouter from '@/mixins/TranslatedRouter';

@Component({})
export default class SignpostCard extends Mixins(TranslatedRouter) {
	@Prop({}) readonly content: TranslateResult;
	@Prop({}) readonly type: string;

	get buttonVariantClass(): string {
		switch (this.type) {
			case 'gold':
				return 'black'
			case 'white':
				return 'white'
			default:
				return 'green';
		}
	}

	getImage(type: any): any {
		return {
			default: process.env.ASSET_BASE + require(`@/images/signpost/${type}@2.jpg`),
			retina: process.env.ASSET_BASE + require(`@/images/signpost/${type}@2.jpg`)
		}
	}

	mounted(): void {
		if (typeof window === 'undefined') {
			return;
		}
	}

	uCFirst(string: string): string {
		return `${string.charAt(0).toLocaleUpperCase()}${string.slice(1)}`;
	}

}

